module.exports = __webpack_public_path__ + "static/img/taiwan_color.5419699.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taiwan_color.png
// module id = 97
// module chunks = 1